import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProjectHardware } from '@app/interfaces/lm/project-hardware';
import {
    ModifyParams,
    OverwriteOneParams,
    OverwriteParams,
    ReleaseListParams,
    ReleaseParams,
} from '@app/interfaces/lm/task-hardware';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TaskHardwareService {
    private baseUrl = environment.api.services.lm + '/task/resource/hardware';

    constructor(private http: HttpClient) {
    }

    async find(params: ReleaseListParams): Promise<string[]> {
        return lastValueFrom(this.http.get<string[]>(`${this.baseUrl}/list`, {
            params: Object.assign(params),
        }));
    }

    async findInfo(data: { hardwares: string[] }): Promise<ProjectHardware[]> {
        return lastValueFrom(this.http.post<ProjectHardware[]>(`${this.baseUrl}/info`, data));
    }

    async release(params: ReleaseParams): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}/release`, params));
    }

    async addResource(params: ReleaseParams): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}/reserve`, params));
    }

    async overwrite(params: OverwriteParams): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}/overwrite`, params));
    }

    async overwriteOne(params: OverwriteOneParams): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}/overwrite/one`, params));
    }

    async modify(params: ModifyParams): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}/modify`, params));
    }
}
